function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7 1.66667H7.29995C4.16662 1.66667 3.92495 4.48334 5.61662 6.01667L14.3833 13.9833C16.075 15.5167 15.8333 18.3333 12.7 18.3333H7.29995C4.16662 18.3333 3.92495 15.5167 5.61662 13.9833L14.3833 6.01667C16.075 4.48334 15.8333 1.66667 12.7 1.66667Z",
  stroke: "#CCD2E3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4075 14C16.0991 15.5333 15.8575 18.35 12.7241 18.35H7.32412C4.19079 18.35 3.94912 15.5333 5.64079 14",
  stroke: "#64D5D2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgDuration = function SvgDuration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDuration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/duration.fd8787b6.svg";
export { ForwardRef as ReactComponent };